export const comments_5588473 = {"data":{"data":[],"links":{}}}